import style from 'styled-components';

export default style.span`
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
`;
